import React, { useState } from 'react';
import { Stack, Card, CardHeader, Box, Button, Switch } from '@mui/material';
import JsFileDownloader from 'js-file-download';
import { getDate, formatDate } from '../../utils/datetime.util';
import { getAppsExportData } from '../../services/reports.service';
import Platforms from '../form-elements/platforms.component';
import Datepicker from '../form-elements/datepicker.component';

const DownloadReports = () => {
  const [filters, setFilters] = useState({
    platform: null,
    combinedPlatforms: true,
    startDate: getDate(-2),
    endDate: getDate(0),
  });

  const handlePlatformChange = (v) => {
    setFilters({
      ...filters,
      platform: v,
    });
  };
  const handleCombinedPlatformsChange = (e) => {
    setFilters({
      ...filters,
      combinedPlatforms: e.target.checked,
    });
  };
  const handleStartDateChange = (v) => {
    setFilters({
      ...filters,
      startDate: v,
    });
  };
  const handleEndDateChange = (v) => {
    setFilters({
      ...filters,
      endDate: v,
    });
  };

  const downloadReport = () => {
    const startDate = formatDate(filters.startDate, 'YYYY-MM-DD');
    const endDate = formatDate(filters.endDate, 'YYYY-MM-DD');
    let downloadFileName = `analytics_${startDate}_${endDate}`;
    let reportType = 'sum_of_two_dates_per_total_app_sessions';

    if (!filters.platform && filters.combinedPlatforms) {
      reportType = 'sum_of_two_dates_per_total_app_sessions_platforms_combined';
    }

    const payload = {
      startDate,
      endDate,
      reportType,
      output: 'csv',
    };
    if (filters.platform?.id) {
      payload.platforms = [filters.platform.id];
      downloadFileName += `_with-platform-${filters.platform.title}`;
    }
    if (!filters.platform && filters.combinedPlatforms) {
      downloadFileName += `_platform_combined`;
    }

    getAppsExportData(payload)
      .then((res) => {
        // eslint-disable-next-line no-unused-vars
        const download = new JsFileDownloader(res, `${downloadFileName}.csv`);
      })
      .catch(() => {
        // to do
      });
  };

  return (
    <Card>
      <CardHeader
        title="Download Reports"
        subheader="Download app visits report"
      />

      <Box sx={{ p: 3, pb: 1 }} dir="ltr">
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Datepicker
            id="dr_start_date"
            name="dr_start_date"
            label="Start Date"
            defaultValue={filters.startDate}
            onChange={handleStartDateChange}
            sx={{ width: 200 }}
            readOnly={filters.loading}
          />
          To
          <Datepicker
            id="dr_end_date"
            name="dr_end_date"
            label="End Date"
            defaultValue={filters.endDate}
            onChange={handleEndDateChange}
            sx={{ width: 200 }}
            readOnly={filters.loading}
          />
        </Stack>
        <Platforms
          id="dr_platform"
          name="dr_platform"
          label="Select Platform"
          defaultValue={filters.platform}
          multiple={false}
          onChange={handlePlatformChange}
          sx={{ width: '100%', my: 2 }}
        />
        <Button
          variant="contained"
          sx={{ my: 2, marginRight: 2 }}
          onClick={downloadReport}
        >
          Download CSV
        </Button>
        <Switch
          checked={filters.combinedPlatforms}
          onChange={handleCombinedPlatformsChange}
          inputProps={{ 'aria-label': 'controlled' }}
          disabled={!!filters.platform}
        />
        &nbsp; All Platforms Combined
      </Box>
    </Card>
  );
};

export default DownloadReports;
